// extracted by mini-css-extract-plugin
module.exports = {"associations":"PdpSharedDealerInfo__associations__75a72e72"};